import apiRequest from "../../helpers/apiRequest";

export default async (id, formData) => {
    return await apiRequest({
        method: 'put',
        url: `studies/update/studymodule/${id}/`,
        data: formData
    })
}
